import { render, staticRenderFns } from "./langPack.vue?vue&type=template&id=6352426a&scoped=true&"
import script from "./langPack.vue?vue&type=script&lang=js&"
export * from "./langPack.vue?vue&type=script&lang=js&"
import style0 from "./langPack.vue?vue&type=style&index=0&id=6352426a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6352426a",
  null
  
)

export default component.exports